/* eslint-disable import/prefer-default-export */
import { css } from "@emotion/react";
import colors from "assets/css/colors";

export const iconCss = css`
  color: ${colors.grey};
`;
